import {
  OnClickReviewsScore,
  OnProductReviewsFetched,
  OnProductReviewsFetchError,
  OnReviewsClose,
  OnReviewsOpen
} from './reviews.types'

export const PRODUCT_REVIEWS_FETCHED = 'PRODUCT_REVIEWS_FETCHED'
export const REVIEWS_OPEN = 'REVIEWS_OPEN'
export const REVIEWS_CLOSE = 'REVIEWS_CLOSE'
export const REVIEWS_SCORE_CLICK = 'REVIEWS_SCORE_CLICK'
export const FETCH_PRODUCT_REVIEWS_ERROR = 'FETCH_PRODUCT_REVIEWS_ERROR'

export const onProductReviewsFetched: OnProductReviewsFetched = (
  productKey,
  response
) => ({
  payload: {
    productKey,
    response
  },
  type: PRODUCT_REVIEWS_FETCHED
})

export const onReviewsOpen: OnReviewsOpen = () => ({
  type: REVIEWS_OPEN
})

export const onReviewsClose: OnReviewsClose = () => ({
  type: REVIEWS_CLOSE
})

export const onClickReviewsScore: OnClickReviewsScore = () => ({
  type: REVIEWS_SCORE_CLICK
})

export const onProductReviewsFetchError: OnProductReviewsFetchError = message => ({
  payload: { message },
  type: FETCH_PRODUCT_REVIEWS_ERROR
})
